/**
 * Created by JasonChou on 17/1/19.
 */

const state = {
  _id: '',
  phone: '',
  nickname: '',
  level: '',
  role: '', // 角色
};

const mutations = {
  // 设置 用户信息
  SET_USER_INFO (state, userInfo) {
    state = Object.assign(state,userInfo)
    if (!state.level) {
      state.level = '普通会员';
    }
  }
};

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/stores/userInfo.js